import { map } from 'lodash/fp';
import { ResourceAssignmentFormValues, ResourceUpdateParameters } from './types';

export const mapResourceAssignmentFormValuesToResourceUpdateParameters = (
    values: ResourceAssignmentFormValues
): Array<ResourceUpdateParameters> => {
    const { resourceIds, assigneeProfileId } = values;

    const updates = map(
        (resourceId) => ({
            resourceId,
            assigneeProfileId: {
                value: assigneeProfileId,
            },
        }),
        resourceIds
    );

    return updates;
};
